import { IMatchDetailDTO } from "../../models/IMatch";
import MatchCard from "../MatchCard";
import { useBracketTree } from "../../hooks/useBracketTree";
import "./styles.scss";

const Bracket: React.FC<{ matches: IMatchDetailDTO[]; readOnly?: boolean }> = ({ matches, readOnly }) => {
  const { leftRounds, rightRounds, finalMatch, thirdPlaceMatch } = useBracketTree(matches);

  return (
    <div className="bracket-container two-sided">
      {/* Left side */}
      <div className="bracket-side right">
        {leftRounds.map((roundMatches, i) => (
          <div key={i} className="bracket-round">
            {roundMatches.map((m) => (
              <MatchCard key={m.id} match={m} readOnly={readOnly} />
            ))}
          </div>
        ))}
      </div>

      {/* Middle */}
      <div className="bracket-middle">
        <div className="bracket-middle">
          <div className="bracket-round">
            {finalMatch && <MatchCard match={finalMatch} readOnly={readOnly} />}
            {thirdPlaceMatch && <MatchCard match={thirdPlaceMatch} readOnly={readOnly} />}
          </div>
        </div>
      </div>

      {/* Right side */}
      <div className="bracket-side left">
        {rightRounds.map((roundMatches, i) => (
          <div key={i} className="bracket-round">
            {roundMatches.map((m) => (
              <MatchCard key={m.id} match={m} readOnly={readOnly} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bracket;
